import { useState, useEffect } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Section, Cell, Caption, Button, Input } from '@telegram-apps/telegram-ui'

import { api } from '../../lib/api'
import type { Settings as SettingsT } from '../../lib/types'
import PageHeader from '../../components/PageHeader'

export default function DirectorSettings() {
  const qc = useQueryClient()
  const { data } = useQuery<SettingsT>({
    queryKey: ['settings'],
    queryFn: () => api.get<SettingsT>('/settings'),
  })

  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')

  useEffect(() => {
    if (data) {
      setFrom(data.quiet_from ?? '')
      setTo(data.quiet_to ?? '')
    }
  }, [data])

  const save = useMutation({
    mutationFn: () => api.put('/settings', {
      quiet_from: from || null,
      quiet_to: to || null,
      reminder_levels: data?.reminder_levels ?? [7, 3, 1, 0],
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['settings'] }),
  })

  return (
    <>
      <PageHeader title="Настройки" />

      <Section header="Часы тишины" footer="В эти часы напоминания не приходят">
        <div style={{ padding: '12px 16px', display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <Caption style={{ marginBottom: 4, display: 'block' }}>С</Caption>
            <Input
              type="time"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              placeholder="22:00"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Caption style={{ marginBottom: 4, display: 'block' }}>До</Caption>
            <Input
              type="time"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              placeholder="08:00"
            />
          </div>
        </div>
        <div style={{ padding: '0 16px 12px' }}>
          <Button stretched size="m" onClick={() => save.mutate()} disabled={save.isPending}>
            Сохранить
          </Button>
        </div>
      </Section>

      <Section header="Напоминания о задачах">
        <Cell subtitle="За 7, 3, 1 день и в день дедлайна">Стандартные</Cell>
      </Section>

      <Section header="О приложении">
        <Cell subtitle="Версия 1.0">Jarvis</Cell>
      </Section>
    </>
  )
}
